import React from 'react';

const ProjectCard = ({ project, onOpen }) => {
  return (
    <div className="project-card">
      <img src={project.imageUrl} alt={project.title} className="project-image" loading="lazy" />
      <h3 className="project-title">{project.title}</h3>
      <p className="project-description">{project.description}</p>
      <p className="project-tools">Tools Used: {project.tools}</p>
      <button className="details-btn" onClick={() => onOpen(project)}>Details</button>
    </div>
  );
};

export default React.memo(ProjectCard);
